import { mapActions } from 'vuex'
import FormSelect from '@/agilis/components/Form/FormSelect/FormSelect.vue'
import FormText from '@/agilis/components/Form/FormText/FormText.vue'

export default {
  name: 'InlineEditor',
  props: {
    value: [String, Number, Object],
    header: Object,
    item: Object,
    existingItems: Array,
    editable: {
      type: Boolean,
      default: true
    },
    onEditDone: Function,
    onChangeDone: Function
  },

  components: {
    FormSelect,
    FormText
  },

  data () {
    return {
      editing: false,
      loading: false,
      inputValue: this.value
    }
  },
  methods: {
    ...mapActions({
      notifyError: 'notificationStore/notifyError'
    }),
    toggleEdit () {
      if (!this.editing) {
        this.editing = true
        setTimeout(() => {
          if (this.$refs?.formText?.$refs?.textInput) {
            this.$refs.formText.$refs.textInput.focus()
          }
        }, 0)
      }
    },

    async editDone (newValue) {
      if (!newValue) return
      if (this.onEditDone && typeof this.onEditDone === 'function') {
        this.loading = true
        try {
          await this.onEditDone(newValue)
        } catch (error) {
          this.notifyError(error)
        }
        this.loading = false
      }
      this.editing = false
    },

    async changeDone (newValue) {
      if (!newValue) return
      if (this.onChangeDone && typeof this.onChangeDone === 'function') {
        this.loading = true
        try {
          await this.onChangeDone(newValue)
        } catch (error) {
          this.notifyError(error)
        }
        this.loading = false
      }
      this.editing = false
    }
  }
}
